import { PropsWithChildren } from 'react'
import MediumZoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

export const Zoom: React.FC<PropsWithChildren> = ({ children }) => {
  return <MediumZoom>{children}</MediumZoom>
}
